<template>
  <div class="weather" style="background-color: #8c939d">
      <span style="width: 100%;font-size: 30px">天气更新</span>
    <el-form  ref="form" :model="form" label-width="80px">
      <el-form-item label="降水量" style="color: black">
        <el-input v-model="form.precipitation"></el-input>
      </el-form-item>
      <el-form-item label="蒸发量">
        <el-input v-model="form.windSpeed"></el-input>
      </el-form-item>
      <el-form-item label="相对湿度">
        <el-input v-model="form.humidity"></el-input>
      </el-form-item>
      <el-form-item label="平均气温">
        <el-input v-model="form.sumEnvirVale"></el-input>
      </el-form-item>
      <el-form-item label="最高气温">
        <el-input v-model="form.maxEnvirVale"></el-input>
      </el-form-item>
      <el-form-item label="最低气温">
        <el-input v-model="form.minEnvirVale"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button  @click="updateWeather()" type="warning" >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { updateWeather } from '@/api/weather'
export default {
  data () {
    return {
      form: {
        precipitation: '',
        windSpeed: '',
        humidity: '',
        sumEnvirVale: '',
        maxEnvirVale: '',
        minEnvirVale: ''
      }
    }
  },
  methods: {
    updateWeather(){
      updateWeather({
        precipitation: this.form.precipitation,
        windSpeed: this.form.windSpeed,
        humidity: this.form.humidity,
        sumEnvirVale: this.form.sumEnvirVale,
        maxEnvirVale: this.form.maxEnvirVale,
        minEnvirVale: this.form.minEnvirVale
      }).then(res => {
        if(res.data){
          this.$message({
            message: '修改气象信息成功',
            type: 'success'
          });
        }else {
          this.$message.error('修改气象信息失败');
        }
      })
    }
  }
}
</script>
<style lang="scss">
.weather {
  margin: auto;
   width: 600px;
  padding: 30px 50px;
}
</style>
